import { Container, Graphics, RenderTexture, Sprite } from "pixi.js"
import { EntityId } from "game-common/models"
import { GuiManager } from "../gui_manager"

// Picture-in-picture "follow cam" opened from the ember roster. Shows the world rendered live,
// centred on a chosen entity, so the player can watch a defender/forager/lord wherever it is in
// the room. The actual world render into `texture` is driven each frame by PixiJsClientRenderer
// (renderWorldToTexture); this widget just owns the texture, frame, title and close button.
//
// TUNABLES (verify live): VIEW_W/H is the window size; ZOOM is the world scale shown inside it
// (1.0 shows ~VIEW_W px of world; raise to zoom in). Keep ZOOM's visible span within the client's
// FOCUS_RENDER_RADIUS or entities will pop at the edges.
const VIEW_W = 260
const VIEW_H = 200
const ZOOM = 1.0
// The overlay renders into the PiP at scale zoom/surfaceZoom (0.5), which pixel-drops bitmap text.
// Render the texture at a higher resolution (2 x devicePixelRatio) so the downscaled text stays legible.
const PIP_RESOLUTION = 2 * (typeof window !== "undefined" && window.devicePixelRatio ? window.devicePixelRatio : 1)
const FRAME = 4
// No title/name header — the PiP is just the framed world view.
const TITLE_H = 0

export class FollowCamModal extends Container {
    private guiManager: GuiManager
    private texture: RenderTexture
    private view: Sprite
    private frame: Graphics
    private isOpen_ = false
    focusEntityId: EntityId | null = null

    constructor(guiManager: GuiManager) {
        super()
        this.guiManager = guiManager

        this.texture = RenderTexture.create({ width: VIEW_W, height: VIEW_H, resolution: PIP_RESOLUTION })

        this.frame = new Graphics()
        this.addChild(this.frame)
        this.drawFrame()

        this.view = new Sprite(this.texture)
        this.view.x = FRAME
        this.view.y = FRAME + TITLE_H
        this.addChild(this.view)

        this.visible = false
    }

    private drawFrame = () => {
        this.frame.clear()
        this.frame.beginFill(0x000000, 0.75)
        this.frame.lineStyle(2, 0xffffff, 0.5)
        this.frame.drawRoundedRect(0, 0, VIEW_W + FRAME * 2, VIEW_H + FRAME * 2 + TITLE_H, 6)
        this.frame.endFill()
    }

    open = (entityId: EntityId, _name?: string) => {
        this.focusEntityId = entityId
        this.isOpen_ = true
        this.visible = true
    }

    close = () => {
        this.isOpen_ = false
        this.visible = false
        this.focusEntityId = null
    }

    isOpen = () => this.isOpen_
    getTexture = () => this.texture
    getZoom = () => ZOOM

    // Outer frame dimensions (for positioning the modal relative to other HUD elements).
    getWidth = () => VIEW_W + FRAME * 2
    getHeight = () => VIEW_H + FRAME * 2 + TITLE_H
}
